import {
  createOrganizationInfoProc,
  updateOrganizationInfoProc,
  readOrganizationInfoProc,
  deleteOrganizationInfoProc,
  flushOrganizationInfoForTesting,
} from '@/appLogic/leanpath/wrappers/';
import { CacheManage, clearDriversTable, getTable, initCacheDataWithDummyDriver, prepareTable } from '@/appLogic/common/cacheManage';
import { bulkUpdateOrganizationInfoProc } from '@/appLogic/leanpath/wrappers/bulkUpdateOrganizationInfoProc';
import { bulkCreateOrganizationInfoProc } from '@/appLogic/leanpath/wrappers/bulkCreateOrganizationInfoProc';

const tableName = 'organizationTbl';

let organizationTable: CacheManage;
/**
 *
 */
const getOrganizationTableSync = () => organizationTable;

/**
 *
 */
const clearOrganizationTable = async () => {
  await getOrganizationTableSync().flush();
  await clearDriversTable(tableName);
};

/**
 *
 */
const clearBusinessDataInServer = async () => {
  await clearOrganizationTable();
  await getOrganizationTableSync().flushForTesting();
};

/**
 *
 * @param connectServer
 */
const prepareOrganizationTable = async (connectServer = true) => {
  if (connectServer) {
    organizationTable = await prepareTable(tableName, 'organizationId', 'dataId', undefined, {
      createAdapter: createOrganizationInfoProc,
      updateAdapter: updateOrganizationInfoProc,
      bulkCreateAdapter: bulkCreateOrganizationInfoProc,
      bulkUpdateAdapter: bulkUpdateOrganizationInfoProc,
      readAdapter2: readOrganizationInfoProc,
      deleteAdapter: deleteOrganizationInfoProc,
      flushForTestingAdapter: flushOrganizationInfoForTesting,
    });
  } else {
    await initCacheDataWithDummyDriver(tableName, 'organizationId', 'dataId');
    organizationTable = await getTable(tableName);
  }
};

export { tableName, prepareOrganizationTable, getOrganizationTableSync, clearOrganizationTable, clearBusinessDataInServer };
